import iFullPhoto from "../../../assets/img/abous-us-page/fullphoto.jpg";
import "./about-us-fullphoto-block.sass";

const AboutUsFullPhotoBlock = () => {
  return <img src={iFullPhoto} className="about-us-fullphoto-block" alt="" />;
};

export default AboutUsFullPhotoBlock;
